import styled from '@emotion/styled'

export const DataNotFoundStyles = styled.div`
  text-align: center;
  color: #707070;
  font-size: 1.2em;
`
